import React, { useState } from 'react'

export default function NoneAddedPopup({ heading, text, buttonText, buttonFn ,borderColor="orange" }) {

    const handlebtn = () => {
        buttonFn("add")
    }
    return (
        <>
            <div className={`banner ${borderColor}`}>
                <div>
                    <h5 style={{fontSize:'18px'}}><b>{heading}</b></h5>
                    <p style={{ margin: "0",fontSize:'16px' }}>{text}</p>
                </div>
                {
                    buttonText !== "DontShow"  ?
                        <div>
                            <button className={`addbtn ${borderColor=="green" ? "" :"colorRed"}`} style={{ padding: "10px 15px",fontSize:'16px' }} onClick={() => handlebtn()}>{buttonText}</button>
                        </div>
                        : ''}
            </div>
        </>
    )
}
